import { usePopularCommanders } from '../../api/hooks'
import PopularGrid from '../builder/PopularGrid'
import { useCommonT } from '../../i18n'

/**
 * Popular commanders band for the returning home hub. Owns its
 * `usePopularCommanders` call so it can be mounted only for returning
 * visitors: conditionally MOUNTING a component that owns a hook is legal,
 * conditionally CALLING a hook is not, so this replaces an earlier version
 * where HomePage called the hook unconditionally (and prefetched for new
 * visitors who never saw the row). Same fail-closed rule as /build's cold
 * state: no data (undefined or empty) renders nothing.
 */
export default function PopularCommandersRow({ onPick }: { onPick: (commander: string) => void }) {
  const t = useCommonT()
  const { data: popular } = usePopularCommanders(6)
  if (!popular || popular.length === 0) return null
  return (
    <section className="space-y-4 text-left">
      <h2 className="text-xs font-semibold uppercase tracking-wide text-gray-400">{t('home.popular')}</h2>
      <PopularGrid names={popular.map((p) => p.name)} onSelect={(name) => onPick(name)} />
    </section>
  )
}
